import React, { useRef, useEffect, Fragment } from 'react'
import styled from 'styled-components'
import { useReadOnly, ReactEditor } from 'vendor/slate-react'
import { Path, Node, Transforms } from 'vendor/slate'
import { DocumentTd } from 'cg/components/documents/editor/slate/documentStyles'

const TableCell = ({ attributes, children, element, editor }) => {
  const readOnly = useReadOnly()
  const { addRowsDisabled } = element

  const deleteTableRow = () => {
    const path = ReactEditor.findPath(editor, element)
    const parentPath = Node.has(editor, path) ? Path.parent(path) : null
    const grandParentPath = Node.has(editor, parentPath) ? Path.parent(parentPath) : null
    const grandParent = grandParentPath ? Node.get(editor, grandParentPath) : null
    if (grandParent && grandParent.children && grandParent.children.length > 1) {
      Transforms.removeNodes(editor, { at: parentPath })
    } else {
      const tablePath = Node.has(editor, grandParentPath) ? Path.parent(grandParentPath) : null
      if (tablePath) Transforms.removeNodes(editor, { at: tablePath })
    }
  }

  return (
    <TD {...attributes} readOnly={readOnly}>
      {children}
      {!readOnly && (
        <>
          {!addRowsDisabled && (
            <TableDeleteRowContainer contentEditable={false} style={{ userSelect: 'none' }}>
              <TableDeleteRow
                onClick={() => {
                  deleteTableRow()
                }}
              >
                <i className="fad fa-trash" />
              </TableDeleteRow>
            </TableDeleteRowContainer>
          )}
        </>
      )}
    </TD>
  )
}

export default TableCell

const TableDeleteRowContainer = styled.div`
  width: 35px;
  right: -30px;
  position: absolute;
  top: 0px;
  display: none;
  height: 100%;
  z-index: 9999;
`

const TD = styled(DocumentTd)`
  &:last-child {
    &:hover {
      ${TableDeleteRowContainer} {
        display: flex;
      }
    }
  }
`

const TableDeleteRow = styled.div`
  width: 25px;
  height: 100%;
  border-radius: 4px;
  background: ${props => props.theme.bgLightestInverse};
  color: ${props => props.theme.textGreyTintedLighter};
  font-size: 13.5px;
  display: flex;
  margin-left: 10px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  -webkit-transition: 0.15s;
  transition: 0.15s;
  &:hover,
  &:active {
    background: ${props => props.theme.primary};
    color: ${props => props.theme.bgSecondLightest};
    border-color: ${props => props.theme.primary};
    box-shadow: none;
  }
`
